const lineHeights = {
  base: '160%',
  short: '140%',
  shorter: '125%',
  tall: '180%',
}

export { lineHeights }
